import request from '@/utils/request'

// ==================== 通用课程题目接口 (t_course_question) ====================

// 添加题目
export function addQuestion(data) {
  return request({
    url: '/course-questions',
    method: 'post',
    data
  })
}

// 根据ID删除题目
export function deleteQuestion(id) {
  return request({
    url: `/course-questions/${id}`,
    method: 'delete'
  })
}

// 批量删除题目
export function batchDeleteQuestions(ids) {
  return request({
    url: `/course-questions/batch/${ids}`,
    method: 'delete'
  })
}

// 根据ID查询单个题目
export function getQuestionById(id) {
  return request({
    url: `/course-questions/detail/${id}`,
    method: 'get'
  })
}

// 根据题目知识点在同题库查找相似题（智能推荐）
export function getSimilarQuestions(id, limit = 3, userId = null) {
  const params = { limit }
  if (userId) {
    params.userId = userId
  }
  return request({
    url: `/course-questions/similar/${id}`,
    method: 'get',
    params
  })
}

// 更新题目
export function updateQuestion(data) {
  return request({
    url: '/course-questions',
    method: 'put',
    data
  })
}

// 批量保存题目
export function saveQuestions(data) {
  return request({
    url: '/course-questions/batch',
    method: 'post',
    data
  })
}

// ==================== 按题库ID查询的接口 ====================

// 按题库ID分页查询题目
export function pagingByRepoId(repoId, params) {
  return request({
    url: `/course-questions/repo/${repoId}/paging`,
    method: 'get',
    params
  })
}

// 按题库ID获取所有题目
export function getAllByRepoId(repoId, knowledgeId = null) {
  return request({
    url: `/course-questions/repo/${repoId}/all`,
    method: 'get',
    params: knowledgeId != null ? { knowledgeId } : {}
  })
}

// 按题库ID获取年份列表
export function listYearsByRepoId(repoId, courseType) {
  return request({
    url: `/course-questions/repo/${repoId}/years`,
    method: 'get',
    params: courseType ? { courseType } : {}
  })
}

// 按题库ID获取难度列表
export function listDifficultiesByRepoId(repoId) {
  return request({
    url: `/course-questions/repo/${repoId}/difficulties`,
    method: 'get'
  })
}

// ==================== 按课程ID查询的接口 ====================

// 按课程ID分页查询题目
export function pagingByCourseId(courseId, params) {
  return request({
    url: `/course-questions/${courseId}/paging`,
    method: 'get',
    params
  })
}

// 按课程ID获取所有题目
export function getAllByCourseId(courseId) {
  return request({
    url: `/course-questions/${courseId}/all`,
    method: 'get'
  })
}

// 按课程ID和题库ID获取题目
export function getByRepoId(courseId, repoId) {
  return request({
    url: `/course-questions/${courseId}/repo/${repoId}`,
    method: 'get'
  })
}

// 按课程ID获取年份列表
export function listYearsByCourseId(courseId, repoId) {
  return request({
    url: `/course-questions/${courseId}/years`,
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

// 按课程ID获取难度列表
export function listDifficultiesByCourseId(courseId) {
  return request({
    url: `/course-questions/${courseId}/difficulties`,
    method: 'get'
  })
}

// 按题库ID获取题目数量
export function countByRepoId(repoId) {
  return request({
    url: `/course-questions/repo/${repoId}/count`,
    method: 'get'
  })
}

// 获取用户在指定题库未做过的一道题
export function getOneUnattemptedQuestion(userId, repoId) {
  return request({
    url: '/course-questions/one-unattempted',
    method: 'get',
    params: { userId, repoId }
  })
}
